/**
 * ACO Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard, ProviderViewGuard]
 */

import { RouteConfig } from '../../types';
import { TodoRoutePlaceholder } from '../../components/TodoRoutePlaceholder';

const AcoTodoPage = () => <TodoRoutePlaceholder pageName="ACO" />;

export const acoRoutes: RouteConfig[] = [
  {
    path: 'AcoPage/*',
    component: AcoTodoPage,
    guards: ['auth', 'vendor', 'provider'],
    data: {
      title: 'ACO',
      breadcrumb: 'ACO',
      preload: false,
      delay: false,
    },
  },
];

